import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Introduction = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">🌟 Introduction to CSS</h1>

      <p className="tutorial-intro">
        CSS (Cascading Style Sheets) is the language used to describe how HTML
        elements should be displayed on screen, paper, or other media. It
        separates content (HTML) from presentation (styles), making websites
        easier to design and maintain.
      </p>

      {/* Why CSS */}
      <div
        style={{
          background: "linear-gradient(135deg, #e0f2fe, #bae6fd)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#0369a1", marginBottom: "0.5rem" }}>
          💡 Why CSS?
        </h2>
        <ul style={{ lineHeight: "1.8", paddingLeft: "1.5rem" }}>
          <li>Improves the look and feel of web pages.</li>
          <li>Makes websites responsive across devices.</li>
          <li>Separates design from structure for cleaner code.</li>
          <li>Allows reusability with external stylesheets.</li>
        </ul>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Basic Example</h2>
        <p>Without CSS, an HTML page looks plain:</p>
        <CodeCopyBlock
          code={`<h1>Hello, World!</h1>
<p>This is my first web page.</p>`}
        />

        <p>Adding CSS makes it more attractive:</p>
        <CodeCopyBlock
          code={`h1 {
  color: #1f7a39;
  text-align: center;
}

p {
  color: #555;
  font-size: 18px;
}`}
        />

        <div
          style={{
            border: "1px solid #ddd",
            padding: "1rem",
            borderRadius: "8px",
            marginTop: "1rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#1f7a39", margin: "0" }}>Hello, World!</h1>
          <p style={{ color: "#555" }}>This is my first web page.</p>
        </div>
      </div>

      {/* How CSS Works */}
      <div className="tutorial-section">
        <h2 className="section-title">⚙️ How CSS Works</h2>
        <p>
          CSS rules are applied by matching <strong>selectors</strong> to HTML
          elements. Each rule has:
        </p>
        <ul className="tutorial-list">
          <li>
            <strong>Selector</strong> – the HTML element you want to style
          </li>
          <li>
            <strong>Property</strong> – the style attribute (like{" "}
            <code>color</code>, <code>font-size</code>)
          </li>
          <li>
            <strong>Value</strong> – the setting for the property
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Now that you know what CSS is, the next step is to learn its{" "}
          <a href="/css/syntax" className="learn-more">
            Syntax
          </a>{" "}
          and how to properly write CSS rules.
        </p>
      </div>
    </div>
  );
};

export default CSS_Introduction;
